import { EventFrequency, EventOccurrence } from '@bonusly/one-on-ones-builders';

import { EventAPIData } from '../../../../types/growth-api';
import { MeetingDTO } from './meeting';
import { UserDTO } from './user';

export class EventDTO {
	static readonly FREQUENCY_SINGLE = 'single';
	static readonly FREQUENCY_WEEKLY = 'weekly';
	static readonly FREQUENCY_BIWEEKLY = 'biweekly';
	static readonly FREQUENCY_MONTHLY = 'monthly';

	id: string;
	companyId: string;
	endTime: Date | null;
	externalCalendarId: string | null;
	externalCalendarLink: string | null;
	externalCalendarProvider: string | null;
	frequency: EventFrequency;
	lastMeetingStartTime: Date | null;
	lastMeetingEndTime: Date | null;
	nextMeetingDate: Date | null;
	nextMeetingEndTime: Date | null;
	nextMeetingId: string | null;
	nextMeetingStartTime: Date | null;
	scheduleDayOfWeek: string;
	scheduleOccurrenceInMonth: EventOccurrence | null;
	shortcodeURL: string;
	startTime: Date | null;
	guestId: string;
	hostId: string;
	managerId: string | null;
	skipManagerId: boolean;
	createdAt: Date;
	updatedAt: Date;
	canceledAt: Date | null = null;
	meetings: MeetingDTO[] = [];

	guest?: UserDTO;
	host?: UserDTO;

	constructor(data: EventAPIData) {
		this.id = data.id;
		this.companyId = data.company_id;
		this.createdAt = new Date(data.created_at);
		this.updatedAt = new Date(data.updated_at);
		this.externalCalendarId = data.external_calendar_id;
		this.externalCalendarLink = data.external_calendar_link;
		this.externalCalendarProvider = data.external_calendar_provider;
		this.frequency = data.frequency;
		this.lastMeetingStartTime = data.last_meeting_start_time ? new Date(data.last_meeting_start_time) : null;
		this.lastMeetingEndTime = data.last_meeting_end_time ? new Date(data.last_meeting_end_time) : null;
		this.scheduleDayOfWeek = data.schedule_day_of_week;
		this.scheduleOccurrenceInMonth = data.schedule_occurrence_in_month;
		this.guestId = data.guest_id;
		this.hostId = data.host_id;
		this.managerId = data.manager_id;
		this.skipManagerId = data.skip_manager_id;
		this.shortcodeURL = data.shortcoded_url;
		this.startTime = null;
		this.endTime = null;
		this.nextMeetingDate = null;
		this.nextMeetingEndTime = data.next_meeting_end_time ? new Date(data.next_meeting_end_time) : null;
		this.nextMeetingId = data.next_meeting_id ?? null;
		this.nextMeetingStartTime = data.next_meeting_start_time ? new Date(data.next_meeting_start_time) : null;

		if (data.next_meeting_date) {
			this.nextMeetingDate = new Date(data.next_meeting_date);
		}
		if (data.start_time) {
			this.startTime = new Date(data.start_time);
		}

		if (data.end_time) {
			this.endTime = new Date(data.end_time);
		}

		if (data.canceled_at) {
			this.canceledAt = new Date(data.canceled_at);
		}
	}

	isCanceled() {
		return !!this.canceledAt;
	}
}
